import angular from 'angular';
import { AddressVerifierService } from './verifier.service';
import { SmartyStreetsModule } from '../smartystreets';

export const AddressVerifierServiceModule = angular
  .module('angular-common.address.verifier', [SmartyStreetsModule.name])
  .service('updAddressVerifier', AddressVerifierService);
